type AvailableRoutes = {
  HOME: string;
  ARTICLES: string;
};

const BASE_ROUTES: AvailableRoutes = {
  HOME: '/',
  ARTICLES: 'article/:id',
};

const ROUTES: { [key: string]: string } = {};

for (const [key, value] of Object.entries(BASE_ROUTES)) {
  if (key != 'HOME') {
    ROUTES[key] = 'dle-api/nkl-api/' + value;
  } else {
    ROUTES[key] = value;
  }
}

export default ROUTES as AvailableRoutes;
